import { useUpdateEffect } from 'utils/hooks';

export const useObligationWorkspaceLifecycle = ({ onSentenceNoteSelectionInRightPanel }) => {
  useUpdateEffect(onSentenceNoteSelectionInRightPanel, [onSentenceNoteSelectionInRightPanel]);
};
